import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

var activeLabelStyles = {
    transform: "scale(0.85) translateY(-24px) translateX(-10px)"
};
var floating = defineStyle({
    // @ts-ignore
    container: {
        _focusWithin: {
            label: __assign({}, activeLabelStyles)
        },
        "input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, .react-date-picker + label,textarea:not(:placeholder-shown) ~ label, .chakra-react-select--has-value + label": __assign({}, activeLabelStyles),
        label: {
            _invalid: {
                color: 'error.500 !important',
            },
            _disable: {
                color: 'neutrals.500 !important',
            },
            top: '0',
            left: '0',
            zIndex: 2,
            position: "absolute",
            backgroundColor: "white",
            pointerEvents: "none",
            mx: 3,
            px: 1,
            my: 2,
            transformOrigin: "left top",
            color: 'neutrals.600'
        },
        ".chakra-form__error-message": {
            color: 'error.500',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            fontSize: '14px'
        },
        ".chakra-form__helper-text": {
            color: 'neutrals.600',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            fontSize: '14px'
        },
        ".chakra-icon": {
            width: '12px',
            height: '12px'
        }
    },
});
var sizes = defineStyle({
    lg: {
        // @ts-ignore
        container: {
            ".chakra-form__label": {
                position: "absolute",
                top: '4px'
            }
        }
    }
});
var formTheme = defineStyleConfig({
    variants: { floating: floating },
    // @ts-ignore
    sizes: sizes
});

export { formTheme };
//# sourceMappingURL=form.js.map
